import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChecked = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 10,
		cy: 10,
		r: 10,
		fill: "#EF4444"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M15.7024 6.66667L9.5575 12.6254C9.15628 13.0144 8.51406 12.9991 8.13182 12.5914L5.70239 10",
		stroke: "white",
		strokeWidth: 1.28571,
		strokeLinecap: "square"
	})]
});
export default SvgChecked;
